import request, { DELETE } from '../../utils/request';

export default mdFileId => request(`/master-data/${mdFileId}`, { method: DELETE });
